import React from 'react'
import PropTypes from 'prop-types'
import {formatDate} from 'lib/dateHelpers'

const PreviousUpsellOrders = ({booking}) => {
  return (
    <div className="upsell photo">
      {booking.orderInvoiceLines.map(line =>
        <div className="upsell-order" key={line.id}>
          <div>
            {line.quantity} x {line.description} - {formatDate(line.createdAt)}
          </div>
          <div>- {line.quantity * line.unitPrice},-</div>
        </div>
      )}
    </div>
  )
}

PreviousUpsellOrders.propTypes = {
  booking: PropTypes.object.isRequired,
}

export default PreviousUpsellOrders
